import React from 'react'
import Helmet from 'react-helmet'
import './style.css'

const Portfolio = () => (
  <div className='portfolio'>
    <Helmet title='Portfolio' />
    <div id='content'>
      <div id='insidebanner'>
        <img
          src='/_ima/previous-projects-banner.jpg'
          alt='Cloud Projects: A proven track record of successful cloud projects'
        />
      </div>
      <div id='inside-left'>
        <div>
          <h2>Previous Clouds and Projects</h2>
          <ul className='portfolio-projects'>
            <li>
              <img
                src='/_ima/mycloudpod.jpg'
                alt='my cloud logo'
              />
              <p>myCloudPod provided a true self-service pod</p>
            </li>
            <li>
              <p className='project-title'>Appko Services Brochure</p>
              <p>
                <a href='/pdf/appko-services-specialbrochure.pdf' download>
                  Appko Services Special Brochure
                </a>
              </p>
            </li>
            <li>
              <p className='project-title'>Appko Nimsoft Integration</p>
              <p>
                <a href='/pdf/appko-nimsoft-solution-brief-cisco-life-2012v2.pdf' download>
          Nimsoft Cloud solution brief
                </a>
              </p>
            </li>
            <li>
              <p className='project-title'>Appko CIAC Integrations</p>
              <p>
                <a href='/pdf/appko-ciac-integrations.pdf' download>
            Appko CIAC Integrations
                </a>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div id='inside-right'>
        <div className='stickybox'>
          <div>
            <p>
              <strong>Phone:</strong>
              1 (408) 600-2860
              <br />
              1 (888) MYAPPKO
              <br />
              <strong>Email:</strong>
              <a href='mailto:sales@appko.com'>sales@appko.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Portfolio
